// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 8,
		title: 'An Eye for an Item',
		category: 'Personal Project',
		blurb: "A robot that finds your lost items in general unstructured indoor environments",
		award: "1st place internationally at NVIDIA + Sparkfun Innovation Challenge",
		img: require('@/assets/images/eye1.jpg'),
	},
	{
		id: 7,
		title: 'Self-Driving Car 3D Perception',
		category: 'Design Team',
		blurb: "LiDAR perception for aUToronto's self-driving car to compete in the SAE AutoDrive Challenge",
		award: "1st place at 2024, 2025, and 2026 SAE AutoDrive Challenge",
		img: require('@/assets/images/car1.png'),
	},
	{
		id: 6,
		title: 'Autonomous Racing Drone Localization',
		category: 'Design Team',
		blurb: "State estimation for an autonomous racing drone for UTAT ADR",
		img: require('@/assets/images/adr.png'),
	},
	{
		id: 5,
		title: 'UTAT UAS: Cyclone',
		category: 'Design Team',
		blurb: "Designing an autonomous hexacopter for the AEAC National UAS Challenge",
		award: "2nd/3rd place Design Report in Canada at AEAC UAS Competition in 2023/2024",
		img: require('@/assets/images/cyclone2.jpeg'),
	},
	{
		id: 4,
		title: 'Touch Guitar',
		category: 'Coursework',
		blurb: "Helping those with arthritis play the guitar",
		img: require('@/assets/images/touchguitar.jpg'),
	},
	{
		id: 3,
		title: 'Autoaim Crossbow',
		category: 'Personal Project',
		blurb: "Autonomously detect, aim and shoot targets",
		img: require('@/assets/images/autoaim.jpg'),
	},
	{
		id: 2,
		title: '3D Chess',
		category: 'Coursework',
		blurb: "A full implementation of the Raumschach variant of 3D Chess, play PVP or against AI",
		img: require('@/assets/images/3DChess.png'),
	},
	{
		id: 1,
		title: 'VEX Robotics Competition',
		category: 'Design Team',
		blurb: "Team Captain, Lead Builder, Programmer, Driver",
		award: "8th place internationally at VEX World Skills Championships in 2021",
		img: require('@/assets/images/vex2.png'),
	},
];

export default projects;
